import { Api } from "../..";
import {
  API_DELETE_ADMIN_USER,
  API_GET_ADMIN_ALL_USERS,
  API_GET_ALL_ADMIN_ROLES_NAMES,
  API_POST_ADMIN_ADD_USER,
  API_POST_INVITE_ADMIN,
  API_PUT_UPDATE_ADMIN_USER,
} from "../../Apis/ApiEndPoints";
import {
  IAdminUser,
  IGetAllAdminRolesResponse,
  IGetAllAdminUsersResponse,
} from "../../models/admin/userManagement/userManagement";
import { ICommonResponse } from "../../models/user/common/Common";
import { CustomAction } from "../../store/customAction";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllAdminUsers = createAsyncThunk(
  "adminUsers/getAllAdminUsers",
  async (_, { dispatch }) => {
    const response: IGetAllAdminUsersResponse = await CustomAction(
      Api.get(API_GET_ADMIN_ALL_USERS),
      dispatch,
      "adminUsers/getAllAdminUsers"
    );
    return response;
  }
);

export const getAllAdminRoles = createAsyncThunk(
  "adminUsers/getAllAdminRoles",
  async (_, { dispatch }) => {
    const response: IGetAllAdminRolesResponse = await CustomAction(
      Api.get(API_GET_ALL_ADMIN_ROLES_NAMES),
      dispatch,
      "adminUsers/getAllAdminRoles"
    );
    return response;
  }
);

export const addNewAdmin = createAsyncThunk(
  "adminUsers/addNewAdmin",
  async (formData: any, { dispatch }) => {
    const response: ICommonResponse = await CustomAction(
      Api.post(API_POST_ADMIN_ADD_USER, formData),
      dispatch,
      "adminUsers/addNewAdmin"
    );
    return response;
  }
);

export const deleteAdmin = createAsyncThunk(
  "adminUsers/deleteAdminUser",
  async (requestParams: string, { dispatch }) => {
    const response: ICommonResponse = await CustomAction(
      Api.delete(`${API_DELETE_ADMIN_USER}?email=${requestParams}`),
      dispatch,
      "adminUsers/deleteAdminUser"
    );
    return response;
  }
);

export const inviteAdminUsers = createAsyncThunk(
  "adminUsers/inviteAdmin",
  async (
    { emails, roles }: { emails: string[]; roles: string[] },
    { dispatch }
  ) => {
    const rolesParam = roles.join(",");
    const response: ICommonResponse = await CustomAction(
      Api.post(
        `${API_POST_INVITE_ADMIN}?roles=${encodeURIComponent(rolesParam)}`,
        emails
      ),
      dispatch,
      "adminUsers/inviteAdmin"
    );
    return response;
  }
);

export const updateAdmin = createAsyncThunk(
  "adminUsers/updateAdmin",
  async (formData: any, { dispatch }) => {
    const response: ICommonResponse = await CustomAction(
      Api.put(API_PUT_UPDATE_ADMIN_USER, formData),
      dispatch,
      "adminUsers/updateAdmin"
    );
    return response;
  }
);
